import React, { useState, useEffect, Suspense } from 'react';
import HospitalManagementAppContent from './HospitalManagementAppContent';
import ErrorBoundary from './ErrorBoundary';
import LoginScreen from './LoginScreen';
import ResetPassword from './ResetPassword';
import { AlertProvider } from './contexts/AlertContext';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ThemeProvider from './contexts/ThemeContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { PatientProvider, AppointmentProvider, StaffProvider, InventoryProvider } from './contexts/DataProviders';
import './styles/animations.css';

const HospitalManagementApp = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isResetPasswordPage, setIsResetPasswordPage] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('lipay_afya_token');
        if (token) {
            setIsAuthenticated(true);
        }

        // Check if we're on the reset password page
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('token') && window.location.pathname.includes('reset-password')) {
            setIsResetPasswordPage(true);
        }
    }, []);

    const handleLoginSuccess = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('lipay_afya_token');
        localStorage.removeItem('user_organization_id');
        setIsAuthenticated(false);
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
            <ThemeProvider>
            <AlertProvider>
                {isResetPasswordPage ? (
                    <ResetPassword onSuccess={handleLoginSuccess} />
                ) : isAuthenticated ? (
                    <NotificationProvider>
                        <AuthProvider>
                            <SettingsProvider>
                                <PatientProvider onLogout={handleLogout}>
                                    <AppointmentProvider onLogout={handleLogout}>
                                        <StaffProvider onLogout={handleLogout}>
                                            <InventoryProvider onLogout={handleLogout}>
                                                <ErrorBoundary>
                                                    <Suspense fallback={<div className="p-6">Loading…</div>}>
                                                        <HospitalManagementAppContent onLogout={handleLogout} />
                                                    </Suspense>
                                                </ErrorBoundary>
                                            </InventoryProvider>
                                        </StaffProvider>
                                    </AppointmentProvider>
                                </PatientProvider>
                            </SettingsProvider>
                        </AuthProvider>
                    </NotificationProvider>
                ) : (
                    <LoginScreen onLoginSuccess={handleLoginSuccess} />
                )}
            </AlertProvider>
            </ThemeProvider>
        </div>
    );
};

export default HospitalManagementApp;